class CustomFilter extends HTMLElement {
  selectors = {
    slider: '.swiper',
    arrows: {
      arrowLeft: '.arrow-left',
      arrowRight: '.arrow-right',
    },
  };

  constructor() {
    super();

    this.links = this.querySelectorAll('a');
    this.accordions = document.querySelectorAll('.faq__accordion');
    this.buttons = this.querySelectorAll('.faq__nav .button');

    this.links.forEach((link) => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        this.toggleActive(link);
        this.filterAccordions();
      });
    });

    this.filterAccordions();
  }

  toggleActive(link) {
    this.links.forEach((el) => {
      if (el == link) {
        return;
      }
      el.classList.remove('active');
      el.classList.add('button--rounded-outlined');
    });

    link.classList.add('active');
    link.classList.remove('button--rounded-outlined');
  }

  filterAccordions() {
    const activeFilters = Array.from(this.querySelectorAll('a.active')).map(
      (link) => link.getAttribute('data-href'),
    );

    this.accordions.forEach((accordion) => {
      const filter = accordion.getAttribute('data-filter');
      if (activeFilters.includes(filter)) {
        accordion.classList.remove('hidden');
      } else {
        accordion.classList.add('hidden');
      }
    });
  }

  connectedCallback() {
    this.elements = {
      slider: this.querySelector(this.selectors.slider),
      arrows: {
        arrowLeft: this.querySelector(this.selectors.arrows.arrowLeft),
        arrowRight: this.querySelector(this.selectors.arrows.arrowRight),
      },
    };

    this.settings = {
      slidesPerView: 'auto',
      spaceBetween: 18,
      navigation: {
        prevEl: this.elements.arrows.arrowLeft,
        nextEl: this.elements.arrows.arrowRight,
      },
      breakpoints: {
        750: {
          slidesPerView: 'auto',
          centeredSlides: true,
          centeredSlidesBounds: true,
          spaceBetween: 18,
        },
      },
    };

    setTimeout(() => {
      this.slider = new Swiper(this.elements.slider, this.settings);
    }, 100);

    if (Shopify.designMode) {
      this.addEventListener(
        'shopify:block:select',
        this.handleBlockSelect.bind(this),
      );
    }
  }

  /**
   * Handle Shopify admin section block select.
   * @param {Object} e Event
   */
  handleBlockSelect(e) {
    const targetIndex = Number(e.target?.getAttribute('data-slide-index'));

    if (!Number.isNaN(targetIndex)) {
      this.slider.slideTo(targetIndex);
    }
  }
}

customElements.define('custom-filter', CustomFilter);
